import { render, staticRenderFns } from "./NewsPreloader.vue?vue&type=template&id=5583c9d6&lang=pug&"
import script from "./NewsPreloader.vue?vue&type=script&lang=js&"
export * from "./NewsPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports